<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="房号" prop="roomName" style="width: 80%">
                <el-input
                  v-model="searchForm.roomName"
                  placeholder="请输入房号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="车位信息"
                prop="parkPosition"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.parkPosition"
                  placeholder="请输入车位信息"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车牌信息" prop="carNo" style="width: 80%">
                <el-input
                  v-model="searchForm.carNo"
                  placeholder="请输入车牌信息"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px; display: flex; align-items: center">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          type="primary"
          style="width: 90px; margin-right: 15px"
          icon="el-icon-download"
        >
          <a :href="baseUrL" download style="color: #fff"
            >下载模板</a
          ></el-button
        >
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action=""
          :http-request="handleUpload"
          :show-file-list="false"
        >
          <el-button
            size="small"
            type="primary"
            style="width: 90px"
            icon="el-icon-upload2"
          >
            导入信息
          </el-button>
        </el-upload>
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="ridgepole" label="楼栋" align="center">
        </el-table-column>
        <el-table-column prop="unit" label="单元" align="center">
        </el-table-column>
        <el-table-column prop="floor" label="楼层" align="center">
        </el-table-column>
        <el-table-column prop="room" label="房间" align="center">
        </el-table-column>                        
        <el-table-column prop="parkPosition" label="车位信息" align="center">
        </el-table-column>
        <el-table-column prop="carNo" label="车牌信息" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="楼栋信息" prop="ridgepoleId">
                <el-select
                  v-model="addData.ridgepoleId"
                  clearable filterable
                  placeholder="请选择"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="addData.ridgepoleId">
              <el-form-item label="单元信息" prop="unitId">
                <el-select
                  v-model="addData.unitId"
                  clearable filterable
                  placeholder="请选择"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="addData.unitId">
              <el-form-item label="楼层信息" prop="floorId">
                <el-select
                  v-model="addData.floorId"
                  clearable filterable
                  placeholder="请选择"
                  @change="floorSelect"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="addData.floorId">
              <el-form-item label="房间信息" prop="roomId">
                <el-select
                  v-model="addData.roomId"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in roomList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车位信息" prop="parkPosition">
                <el-input
                  v-model="addData.parkPosition"
                  placeholder="请输入车位信息"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌信息" prop="carNo">
                <el-input
                  v-model="addData.carNo"
                  placeholder="请输入车牌信息"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "../../utils/reg";
export default {
  props: {
    fieldId: Number,
  },
  data() {
    return {
      searchForm: {
        parkPosition: "",
        carNo: "",
        roomName: "",
      },
      baseUrL:
        process.env.VUE_APP_UPLOAD_REAL_PATH + "/user-vehicle/importTemplate",
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        carNo: "",
        parkPosition: "",
        roomId: "",
        unitId:"",
        floorId:""
      },
      addDataRules: {
        ridgepoleId: [
          { required: true, message: "请选择楼栋", trigger: "blur" },
        ],
        unitId: [{ required: true, message: "请选择单元", trigger: "blur" }],
        floorId: [{ required: true, message: "请选择楼层", trigger: "blur" }],
        roomId: [{ required: true, message: "请选择房间", trigger: "blur" }],
        parkPosition: [{ required: true, message: "请输入车位信息", trigger: "blur" }],
        carNo: [
          { required: true, message: "请输入车牌信息", trigger: "blur" },
          // {
          //   validator: function (rule, value, callback) {
          //     if (!reg.carNo(value)) {
          //       callback(new Error("请输入正确车牌号码"));
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: "blur",
          // },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      ridgepoleList: [],
      unitList: [],
      floorList: [],
      roomList: [],
      userRoomList: [],
      roomUserId: "",
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 选择楼栋
    ridgepoleSelect(e) {
      this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
        if (res.code == 200) {
          this.addData.unitId = ""
          this.addData.floorId = ""
          this.addData.roomId = ""
          this.unitList = res.data;
        }
      });
    },
    // 选择单元
    unitSelect(e) {
      this.$Apis.floorAllList({ unitId: e }).then((res) => {
        if (res.code == 200) {
          this.addData.floorId = ""
          this.addData.roomId = ""
          this.floorList = res.data;
        }
      });
    },
    // 选择楼层
    floorSelect(e,room) {
      this.$Apis.roomAllList({ floorId: e }).then((res) => {
        if (res.code == 200) {
          this.roomList = res.data;
          this.addData.roomId = ""
          if(room == 'room'){
            this.isAddModal = true;
          }
        }
      });
    },
    // 房间信息导入
    handleUpload({ file }) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "上传中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        var formData = new FormData();
        formData.append("file", file);
        formData.append(
          "villageId",
          JSON.parse(localStorage.getItem("park_data")).id
        );
        this.$Apis.vehicleImportCreateVehicle(formData).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
          loading.close();
        });
      } catch (error) {
        loading.close();
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.ridgepoleSelect(this.addData.ridgepoleId)
      this.unitSelect(this.addData.unitId)
      this.floorSelect(this.addData.floorId,'room')
      console.log(this.addData)
    },
    //删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.vehicleDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            carNo: this.addData.carNo,
            parkPosition: this.addData.parkPosition,
            roomId: this.addData.roomId,
          };
          this.$Apis.vehicleAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm,
      };
      this.$Apis.houseAllList().then((res) => {
        if (res.code == 200) {
          this.ridgepoleList = res.data;
        }
      });
      this.$Apis.vehicleList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
.actice .el-upload--picture-card {
  display: none !important;
}
/deep/.el-upload-list {
  display: none;
}
</style>